module.exports = __webpack_public_path__ + "static/media/course.d553b9a5.webp";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/v2/home/course.webp
// module id = 538
// module chunks = 4